import React from 'react';
import ChevronLeftIcon from '../../../shared/components/Icons/ChevronLeft';
import ChevronRightIcon from '../../../shared/components/Icons/ChevronRight';
import Styled from './styled';

interface Props {
  onClick?: (any) => void;
}

export const NextArrow = ({ onClick }: Props) => (
  <Styled.NextArrow onClick={onClick}>
    <ChevronRightIcon />
  </Styled.NextArrow>
);

export const PrevArrow = ({ onClick }: Props) => (
  <Styled.PrevArrow onClick={onClick}>
    <ChevronLeftIcon />
  </Styled.PrevArrow>
);
